import { render, staticRenderFns } from "./dustMonitorDetail.vue?vue&type=template&id=62d83a9f&scoped=true&"
import script from "./dustMonitorDetail.vue?vue&type=script&lang=js&"
export * from "./dustMonitorDetail.vue?vue&type=script&lang=js&"
import style0 from "./dustMonitorDetail.vue?vue&type=style&index=0&id=62d83a9f&scoped=true&lang=css&"
import style1 from "./dustMonitorDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d83a9f",
  null
  
)

export default component.exports